import React, { useState, useEffect, useMemo } from "react";
import { withNamespaces } from "react-i18next";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Spinner } from "reactstrap";
import Select from 'react-select';
import { useMutation } from "@tanstack/react-query";
import ControlService from "src/modules/data-protection/apis/ControlService";
import { toast } from "react-toastify";

const EditMaturityModal = ({ t, isOpen, toggle, controlId, currentValue, onSaved }) => {
    const [value, setValue] = useState();

    const saveMaturityLevel = useMutation({
        mutationFn: async (payload) => {
            const service = ControlService.getInstance();
            return await service.updateMaturityLevel(controlId, payload);
        },
        onSuccess: () => {
            toast(t("Maturity Level updated successfully."), {
                type: "success"
            });

            toggle();

            onSaved && onSaved();
        },
        onError: () => {
            toast(t("Failed to update Maturity Level. Please try again."), {
                type: "error"
            });
        }
    });

    const handleSave = () => {
        saveMaturityLevel.mutate({
            maturity_level: value.value
        });
    };

    const levels = useMemo(() => {
        return [
            {
                value: '0',
                label: t('Incomplete')
            },
            {
                value: '1',
                label: t('Performed')
            },
            {
                value: '2',
                label: t('Managed')
            },
            {
                value: '3',
                label: t('Established')
            },
            {
                value: '4',
                label: t('Predictable')
            },
            {
                value: '5',
                label: t('Optimizing')
            }
        ]
    }, [ t ]);

    useEffect(() => {
        if (isOpen) {
            if (typeof currentValue !== undefined) {
                const level = levels.find((l) => l.value === currentValue?.toString());

                if (level) {
                    setValue(level);
                }
                else {
                    setValue(null);
                }
            }
        }
        else {
            setValue(null);
        }
    }, [
        isOpen,
        currentValue,
        levels
    ]);

    return (
        <Modal isOpen={isOpen} toggle={toggle} centered>
            <ModalHeader toggle={toggle}>
                {t('Edit Maturity Level')}
            </ModalHeader>

            <ModalBody>
                <p>
                    {t('Select a new maturity level for this control')}:
                </p>

                <div>
                    <Select
                        name='type'
                        classNamePrefix='select2-selection'
                        options={levels}
                        placeholder={t('Select...')}
                        value={value}
                        onChange={(e) => setValue(e)}
                    />
                </div>
            </ModalBody>

            <ModalFooter>
                <Button color="secondary" onClick={toggle}>
                    {t('Cancel')}
                </Button>
                <Button     
                    color="primary" 
                    onClick={handleSave} 
                    disabled={!value || saveMaturityLevel.isLoading}
                >
                    {saveMaturityLevel.isLoading && (
                        <Spinner size="sm" className="me-2" />
                    )}

                    {t('Save')}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default withNamespaces()(
    EditMaturityModal
);
